import constants from '@/app-configs/constants'
// import apisettings from './apisettings'

export default [
  {
    title: 'DEBTIA_SETTINGS',
    icon: 'GridIcon',
    action: constants.action.permissionLogin,
    resource: constants.resource.user,
    children: [
      {
        title: 'DEBTIA_API_SETTINGS',
        icon: 'GridIcon',
        route: 'apisettings',
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
      {
        title: 'DEBTIA_ADMIN_SETTINGS',
        route: 'admin-settings',
        icon: 'GridIcon',
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    ],
  },
]
